<template>
  <van-popup v-model="visible" position="center" round :style="{ width: '90%', maxWidth: '560px', height: '80vh', maxHeight: '720px' }" :close-on-click-overlay="false">
    <div class="onboarding-container">
      <!-- Skip button -->
      <div class="onboarding-skip" @click="finish(true)">
        {{ $t('onboarding_skip') }}
      </div>

      <!-- Step content -->
      <div class="onboarding-body">
        <div class="onboarding-animation">
          <!-- Step 1: AI Chat + Hub Card -->
          <div v-if="currentStep === 0" class="step-animation step1-animation" key="step1">
            <div class="step1-stack">
              <!-- Group chat card -->
              <div class="hub-card" :class="{ 'animate-in': currentStep === 0 }">
                <div class="hub-header">
                  <div class="hub-icon"><van-icon name="friends-o" size="16" color="#E8543A" /></div>
                  <div class="hub-name-placeholder"></div>
                  <div class="hub-more"><van-icon name="ellipsis" size="12" color="#bbb" /></div>
                </div>
                <div class="hub-messages">
                  <!-- User message (right) -->
                  <div class="msg-row msg-right" :class="{ 'slide-in-right': currentStep === 0 }">
                    <div class="msg-bubble msg-bubble-right">
                      <div class="typing-line typing-line-1"></div>
                      <div class="typing-line typing-line-2"></div>
                    </div>
                    <div class="avatar avatar-red"><van-icon name="user-o" size="10" color="#E8543A" /></div>
                  </div>
                  <!-- Other member reply (left) -->
                  <div class="msg-row msg-left" :class="{ 'slide-in-left': currentStep === 0 }">
                    <div class="avatar avatar-blue"><van-icon name="user-o" size="10" color="#3DAECF" /></div>
                    <div class="msg-bubble msg-bubble-left">
                      <div class="typing-line typing-line-3"></div>
                    </div>
                  </div>
                  <!-- Another member reply (left) -->
                  <div class="msg-row msg-left" :class="{ 'slide-in-left-delay': currentStep === 0 }">
                    <div class="avatar avatar-green"><van-icon name="user-o" size="10" color="#34A853" /></div>
                    <div class="msg-bubble msg-bubble-left">
                      <div class="typing-line typing-line-4"></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- AI chat dialog (overlapping on top) -->
              <div class="ai-chat-dialog" :class="{ 'animate-in-ai': currentStep === 0 }">
                <div class="ai-header">
                  <div class="ai-logo">
                    <img src="/static/logo-transparent.png" alt="" class="ai-logo-img" />
                  </div>
                  <div class="ai-name-placeholder"></div>
                </div>
                <div class="ai-typing">
                  <div class="ai-typing-line ai-line-1"></div>
                  <div class="ai-typing-line ai-line-2"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Step 2: AI Continuous Match (摇摇持续匹配) -->
          <div v-if="currentStep === 1" class="step-animation step2-animation" key="step2">
            <div class="shake-container" :class="{ 'shaking': currentStep === 1 }">
              <!-- Center logo -->
              <div class="shake-center" :class="{ 'pulse-ring': currentStep === 1 }">
                <img src="/static/logo-transparent.png" alt="" class="shake-logo-img" />
              </div>
              <!-- Orbiting dots -->
              <div class="orbit-dot dot-1" :class="{ 'converge': currentStep === 1 }"></div>
              <div class="orbit-dot dot-2" :class="{ 'converge': currentStep === 1 }"></div>
              <div class="orbit-dot dot-3" :class="{ 'converge': currentStep === 1 }"></div>
              <div class="orbit-dot dot-4" :class="{ 'converge': currentStep === 1 }"></div>
              <div class="orbit-dot dot-5" :class="{ 'converge': currentStep === 1 }"></div>
              <div class="orbit-dot dot-6" :class="{ 'converge': currentStep === 1 }"></div>
              <!-- Sparkles -->
              <div class="sparkle sparkle-1" :class="{ 'sparkle-show': currentStep === 1 }">&#10022;</div>
              <div class="sparkle sparkle-2" :class="{ 'sparkle-show': currentStep === 1 }">&#10022;</div>
              <div class="sparkle sparkle-3" :class="{ 'sparkle-show': currentStep === 1 }">&#10022;</div>
              <div class="sparkle sparkle-4" :class="{ 'sparkle-show': currentStep === 1 }">&#10022;</div>
            </div>
          </div>

          <!-- Step 3: Hub Chat Connect -->
          <div v-if="currentStep === 2" class="step-animation step3-animation" key="step3">
            <div class="connect-container">
              <!-- Group messages -->
              <div class="connect-messages">
                <div class="connect-msg connect-msg-left" :class="{ 'fade-slide-in': currentStep === 2 }">
                  <div class="connect-avatar avatar-orange"><van-icon name="user-o" size="10" color="#F5A623" /></div>
                  <div class="connect-bubble"></div>
                </div>
                <div class="connect-msg connect-msg-right" :class="{ 'fade-slide-in-d1': currentStep === 2 }">
                  <div class="connect-bubble"></div>
                  <div class="connect-avatar avatar-blue2"><van-icon name="user-o" size="10" color="#3DAECF" /></div>
                </div>
                <div class="connect-msg connect-msg-left" :class="{ 'fade-slide-in-d2': currentStep === 2 }">
                  <div class="connect-avatar avatar-green2"><van-icon name="user-o" size="10" color="#34A853" /></div>
                  <div class="connect-bubble"></div>
                </div>
                <div class="connect-msg connect-msg-right" :class="{ 'fade-slide-in-d3': currentStep === 2 }">
                  <div class="connect-bubble"></div>
                  <div class="connect-avatar avatar-red2"><van-icon name="user-o" size="10" color="#E8543A" /></div>
                </div>
              </div>
              <!-- Two highlighted avatars sliding out -->
              <div class="connect-highlight-left" :class="{ 'slide-out-left': currentStep === 2 }">
                <div class="highlight-avatar highlight-orange"><van-icon name="user-o" size="20" color="#F5A623" /></div>
              </div>
              <div class="connect-highlight-right" :class="{ 'slide-out-right': currentStep === 2 }">
                <div class="highlight-avatar highlight-blue"><van-icon name="user-o" size="20" color="#3DAECF" /></div>
              </div>
              <!-- Connection line -->
              <div class="connect-line" :class="{ 'line-grow': currentStep === 2 }"></div>
              <!-- Chat icon -->
              <div class="connect-chat-icon" :class="{ 'bounce-in': currentStep === 2 }">
                <van-icon name="chat-o" size="20" color="#3DAECF" />
              </div>
            </div>
          </div>
        </div>

        <!-- Title -->
        <div class="onboarding-title" :class="{ 'title-shake': currentStep === 1 }">
          {{ steps[currentStep].title }}
        </div>

        <!-- Description -->
        <div class="onboarding-desc">
          {{ steps[currentStep].description }}
        </div>
      </div>

      <!-- Bottom controls -->
      <div class="onboarding-bottom">
        <!-- Indicators -->
        <div class="onboarding-indicators">
          <div
            v-for="(step, index) in steps"
            :key="index"
            class="indicator-dot"
            :class="{ 'indicator-active': index === currentStep }"
          ></div>
        </div>

        <!-- Next / Start button -->
        <div class="onboarding-btn" @click="nextStep">
          <span>{{ isLast ? $t('onboarding_getStarted') : $t('onboarding_next') }}</span>
          <van-icon v-if="!isLast" name="arrow" size="14" color="#fff" style="margin-left: 6px;" />
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { AI_DIRECT_CHAT_ENABLED } from '@/assets/feature_flags.js'

export default {
  name: 'OnboardingPage',
  data() {
    return {
      currentStep: 0,
    }
  },
  computed: {
    visible: {
      get() { return this.$store.state.showOnboarding },
      set(val) { this.$store.commit('setShowOnboarding', val) }
    },
    steps() {
      return [
        { title: this.$t('onboarding_step1Title'), description: this.$t('onboarding_step1Desc') },
        { title: this.$t('onboarding_step2Title'), description: this.$t('onboarding_step2Desc') },
        { title: this.$t('onboarding_step3Title'), description: this.$t('onboarding_step3Desc') },
      ]
    },
    isLast() {
      return this.currentStep === this.steps.length - 1
    }
  },
  methods: {
    nextStep() {
      if (this.isLast) {
        this.finish()
      } else {
        this.currentStep++
      }
    },
    finish(skipped) {
      this.visible = false
      if (this.$common && this.$common.isLocalStorageAvailable && this.$common.isLocalStorageAvailable()) {
        window.localStorage.setItem('hasCompletedOnboarding', '1')
      }
      // 对齐 client/ home_page + onboarding_page：「Get Started」结束自动进 AI 对话（Skip 则不进），
      // web 端打开全局 AI 对话弹窗。AI 直聊入口开关关闭时不再自动打开（store 兜底也会拦）
      if (!skipped && AI_DIRECT_CHAT_ENABLED) {
        this.$store.commit('setShowAiChatPopup', true)
      }
    }
  }
}
</script>

<style scoped>
.onboarding-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #FEF0ED 0%, #ffffff 50%, #E8F7FB 100%);
  position: relative;
  overflow: hidden;
}

.onboarding-skip {
  position: absolute;
  top: 12px;
  right: 16px;
  font-size: 14px;
  color: #8A8A8A;
  cursor: pointer;
  z-index: 10;
  padding: 8px 12px;
}

.onboarding-skip:hover {
  color: #8A8A8A;
}

.onboarding-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 48px 24px;
  min-height: 0;
}

.onboarding-animation {
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.step-animation {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.onboarding-title {
  font-size: 28px;
  font-weight: 700;
  color: #1A1A1A;
  margin-top: 32px;
  text-align: center;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}

.onboarding-desc {
  font-size: 16px;
  color: #8A8A8A;
  margin-top: 16px;
  text-align: center;
  line-height: 1.6;
  max-width: 420px;
  flex-shrink: 0;
}

.onboarding-bottom {
  padding: 0 48px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.onboarding-indicators {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
}

.indicator-dot {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #ddd;
  transition: all 0.3s ease;
}

.indicator-active {
  width: 24px;
  background: #E8543A;
}

.onboarding-btn {
  width: 200px;
  height: 50px;
  border-radius: 16px;
  background: linear-gradient(135deg, #E8543A, #F07058);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(214, 78, 60, 0.35);
  transition: transform 0.2s;
}

.onboarding-btn:active {
  transform: translateY(1px);
}

/* ===== Step 1: AI Chat + Group Card ===== */
.step1-stack {
  position: relative;
  width: 340px;
  height: 300px;
}

.hub-card {
  position: absolute;
  top: 40px;
  left: 0;
  width: 340px;
  background: #fff;
  border-radius: 20px;
  padding: 18px;
  box-shadow: 0 8px 20px rgba(214, 78, 60, 0.1);
  opacity: 0;
  transform: scale(0.85);
  transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.hub-card.animate-in {
  opacity: 1;
  transform: scale(1);
}

.hub-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.hub-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(214, 78, 60, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.hub-name-placeholder {
  width: 72px;
  height: 10px;
  background: #E0DDD8;
  border-radius: 4px;
  margin-left: 8px;
}

.hub-more {
  margin-left: auto;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #F7F5F2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hub-messages {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.msg-row {
  display: flex;
  align-items: flex-end;
  gap: 5px;
  opacity: 0;
}

.msg-right {
  justify-content: flex-end;
}

.msg-left {
  justify-content: flex-start;
}

.msg-right.slide-in-right {
  animation: slideInRight 0.5s 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

.msg-left.slide-in-left {
  animation: slideInLeft 0.5s 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

.msg-left.slide-in-left-delay {
  animation: slideInLeft 0.5s 1.0s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

@keyframes slideInRight {
  from { opacity: 0; transform: translateX(30px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes slideInLeft {
  from { opacity: 0; transform: translateX(-30px); }
  to { opacity: 1; transform: translateX(0); }
}

.msg-bubble {
  padding: 9px 13px;
  border-radius: 14px;
}

.msg-bubble-right {
  background: rgba(214, 78, 60, 0.08);
  border-radius: 14px 14px 4px 14px;
}

.msg-bubble-left {
  background: #fff;
  border-radius: 14px 14px 14px 4px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}

.typing-line {
  height: 9px;
  border-radius: 4px;
}

.typing-line-1 {
  width: 110px;
  background: rgba(214, 78, 60, 0.2);
  margin-bottom: 5px;
}

.typing-line-2 {
  width: 72px;
  background: rgba(214, 78, 60, 0.12);
}

.typing-line-3 {
  width: 85px;
  background: #E0DDD8;
}

.typing-line-4 {
  width: 65px;
  background: #E0DDD8;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 16%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  flex-shrink: 0;
}

.avatar-red {
  background: #FEF0ED;
}

.avatar-blue {
  background: #E8F7FB;
}

.avatar-green {
  background: #E8F5E9;
}

/* AI chat dialog */
.ai-chat-dialog {
  position: absolute;
  top: 0;
  left: -50px;
  width: 190px;
  background: #fff;
  border-radius: 16px;
  padding: 14px;
  box-shadow: 2px 4px 16px rgba(214, 78, 60, 0.12);
  z-index: 2;
  opacity: 0;
  transform: scale(0.7);
  transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.ai-chat-dialog.animate-in-ai {
  opacity: 1;
  transform: scale(1);
}

.ai-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.ai-logo {
  width: 26px;
  height: 26px;
  border-radius: 16%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-logo-img {
  width: 20px;
  height: 20px;
}

.ai-name-placeholder {
  width: 48px;
  height: 8px;
  background: #E0DDD8;
  border-radius: 3px;
  margin-left: 5px;
}

.ai-typing {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ai-typing-line {
  height: 8px;
  border-radius: 4px;
}

.ai-line-1 {
  width: 90px;
  background: rgba(214, 78, 60, 0.2);
}

.ai-line-2 {
  width: 62px;
  background: rgba(214, 78, 60, 0.12);
}

/* ===== Step 2: AI Continuous Match (摇摇持续匹配) ===== */
.shake-container {
  position: relative;
  width: 280px;
  height: 280px;
}

.shake-container.shaking {
  animation: globalShake 2.5s ease-in-out infinite;
}

@keyframes globalShake {
  0%, 100% { transform: translate(0, 0); }
  10% { transform: translate(-1.5px, 1px); }
  20% { transform: translate(1.5px, -1px); }
  30% { transform: translate(-1px, 1.5px); }
  40% { transform: translate(1px, -1.5px); }
  50% { transform: translate(-1.5px, 0.5px); }
  60% { transform: translate(1.5px, -0.5px); }
  70% { transform: translate(0, 0); }
}

.shake-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 8px 24px rgba(214, 78, 60, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.shake-center.pulse-ring::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid rgba(214, 78, 60, 0.6);
  animation: pulseExpand 2.5s 1.8s ease-out infinite;
}

@keyframes pulseExpand {
  0% { transform: scale(1); opacity: 0.8; }
  100% { transform: scale(1.8); opacity: 0; }
}

.shake-logo-img {
  width: 60px;
  height: 60px;
}

.orbit-dot {
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(214, 78, 60, 0.5);
  box-shadow: 0 0 8px rgba(214, 78, 60, 0.2);
  transition: all 2s cubic-bezier(0.4, 0, 0.2, 1);
}

.dot-1 { top: 10%; left: 50%; width: 18px; height: 18px; }
.dot-2 { top: 30%; left: 85%; width: 16px; height: 16px; }
.dot-3 { top: 70%; left: 80%; width: 20px; height: 20px; }
.dot-4 { top: 85%; left: 40%; width: 14px; height: 14px; }
.dot-5 { top: 60%; left: 10%; width: 17px; height: 17px; }
.dot-6 { top: 20%; left: 15%; width: 19px; height: 19px; }

.orbit-dot.converge {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%);
  background: rgba(214, 78, 60, 0.85);
  box-shadow: 0 0 12px rgba(214, 78, 60, 0.5);
}

.dot-1.converge { transition-delay: 0s; width: 20px; height: 20px; }
.dot-2.converge { transition-delay: 0.1s; width: 18px; height: 18px; }
.dot-3.converge { transition-delay: 0.2s; width: 22px; height: 22px; }
.dot-4.converge { transition-delay: 0.15s; width: 16px; height: 16px; }
.dot-5.converge { transition-delay: 0.25s; width: 19px; height: 19px; }
.dot-6.converge { transition-delay: 0.05s; width: 21px; height: 21px; }

.sparkle {
  position: absolute;
  font-size: 16px;
  color: rgba(214, 78, 60, 0.7);
  opacity: 0;
  transition: opacity 0.5s ease, transform 0.5s ease;
  z-index: 3;
}

.sparkle-show {
  opacity: 1;
  transform: scale(1.2);
}

.sparkle-1 { top: -5%; left: 50%; font-size: 18px; transition-delay: 1.8s; }
.sparkle-2 { top: 25%; right: -5%; font-size: 14px; transition-delay: 2s; }
.sparkle-3 { bottom: 10%; left: -5%; font-size: 20px; transition-delay: 2.2s; }
.sparkle-4 { bottom: -5%; right: 20%; font-size: 16px; transition-delay: 2.4s; }

/* Title shake for step 2 */
.title-shake {
  animation: titleShake 0.9s ease-in-out infinite alternate;
}

@keyframes titleShake {
  0% { transform: rotate(0deg); }
  25% { transform: rotate(1.5deg); }
  50% { transform: rotate(-1deg); }
  75% { transform: rotate(1deg); }
  100% { transform: rotate(-1.5deg); }
}

/* ===== Step 3: Group Chat Connect ===== */
.connect-container {
  position: relative;
  width: 300px;
  height: 260px;
}

.connect-messages {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.connect-msg {
  display: flex;
  align-items: flex-end;
  gap: 5px;
  opacity: 0;
}

.connect-msg-left {
  justify-content: flex-start;
}

.connect-msg-right {
  justify-content: flex-end;
}

.connect-msg.fade-slide-in {
  animation: fadeSlideIn 0.4s 0s ease-out forwards;
}

.connect-msg.fade-slide-in-d1 {
  animation: fadeSlideIn 0.4s 0.15s ease-out forwards;
}

.connect-msg.fade-slide-in-d2 {
  animation: fadeSlideIn 0.4s 0.3s ease-out forwards;
}

.connect-msg.fade-slide-in-d3 {
  animation: fadeSlideIn 0.4s 0.45s ease-out forwards;
}

@keyframes fadeSlideIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.connect-avatar {
  width: 30px;
  height: 30px;
  border-radius: 16%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #fff;
  flex-shrink: 0;
}

.avatar-orange { background: #FFF3E0; }
.avatar-blue2 { background: #E8F7FB; }
.avatar-green2 { background: #E8F5E9; }
.avatar-red2 { background: #FEF0ED; }

.connect-bubble {
  width: 90px;
  height: 10px;
  background: #eee;
  border-radius: 4px;
}

/* Highlighted avatars sliding out */
.connect-highlight-left,
.connect-highlight-right {
  position: absolute;
  top: 50%;
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.connect-highlight-left {
  left: 50%;
  transform: translate(-50%, -50%);
}

.connect-highlight-right {
  right: 50%;
  transform: translate(50%, -50%);
}

.connect-highlight-left.slide-out-left {
  opacity: 1;
  left: -10px;
  transform: translate(0, -50%);
  transition-delay: 0.8s;
}

.connect-highlight-right.slide-out-right {
  opacity: 1;
  right: -10px;
  transform: translate(0, -50%);
  transition-delay: 0.9s;
}

.highlight-avatar {
  width: 60px;
  height: 60px;
  border-radius: 16%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2.5px solid rgba(0, 191, 165, 0.6);
  box-shadow: 0 0 12px rgba(0, 191, 165, 0.3);
}

.highlight-orange { background: #FFF3E0; }
.highlight-blue { background: #E8F7FB; }

/* Connection line */
.connect-line {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, rgba(0, 191, 165, 0.3), #3DAECF, rgba(0, 191, 165, 0.3));
  border-radius: 2px;
  transition: width 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
  transition-delay: 1.1s;
}

.connect-line.line-grow {
  width: 130px;
}

/* Chat icon */
.connect-chat-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(0, 191, 165, 0.25);
  transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  transition-delay: 1.4s;
}

.connect-chat-icon.bounce-in {
  transform: translate(-50%, -50%) scale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/OnboardingPage.vue